var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('input',{ref:_vm.reference,attrs:{"type":"radio","id":_vm.id,"name":_vm.name},domProps:{"value":_vm.value,"checked":_vm.checked==_vm.value},on:{"change":function($event){return _vm.$emit('change', $event.target.value)}}}),_c('label',{staticClass:"label",attrs:{"for":_vm.id}},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }